import React, { useState, useRef } from 'react';
import Box from '@mui/material/Box';
import {isDesktop} from 'react-device-detect';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker } from 'react-leaflet'

import 'leaflet/dist/leaflet.css';
import './style.css'

const redIcon = new L.Icon({
    iconUrl: `${process.env.REACT_APP_CDN_BASE_URL}/public/assets/pin-red.png`,
    iconSize: [21, 34],
    iconAnchor: [10, 34]
});

L.Marker.prototype.options.icon = redIcon;

const LocationMarker = (props) => {
    const [position] = useState(props.position);
    const markerRef = useRef(null);

    const marker = markerRef.current;
    if (marker != null) {
        marker.setLatLng(props.position);
    }

    return position === null ? null : (
        <Marker position={position} ref={markerRef}></Marker>

    )
};

const interactionOptions = {
    zoomControl: isDesktop,
    doubleClickZoom: isDesktop,
    closePopupOnClick: false,
    dragging: false,
    zoomSnap: false,
    zoomDelta: false,
    trackResize: false,
    touchZoom: false,
    scrollWheelZoom: false,
};

export default function AddressStatic({location}) {
    const [map, setMap] = useState(null);
    console.log('[AddressStatic]');
    if (map != null && location) {
        map.setView([location.lat, location.lng], 16);
    }

    return (
        <Box style={{width: 'inherit', height: 'inherit'}}>
            {location &&
            <MapContainer className="static-map"
                          center={[location.lat, location.lng]}
                          zoom={16}
                          {...interactionOptions}
                          whenCreated={setMap}
                          scrollWheelZoom={false}>
                <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright" target="_blank">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <LocationMarker effectOn={this} position={[location.lat, location.lng]} />
            </MapContainer>
            }
        </Box>
    )
};